import { FloatingWindowCard } from "@bezoned/shared/components/floating-window/floating-window-card.jsx";

import { useLayoutStore } from "../../store/layout.store.js";
import { FloatingWindowRenderer } from "./floating-window-renderer.js";
import { RosterView } from "./roster/roster-view.js";
import {
  ROSTER_WINDOW_TRANSITION_MS,
  useRosterWindow,
} from "./use-roster-window.js";

export const RosterWindow = () => {
  const avatarMenu = useLayoutStore((state) => state.avatarMenu);
  const hidePersonRoster = useLayoutStore((state) => state.hidePersonRoster);
  const personRosterVisible = useLayoutStore(
    (state) => state.personRosterVisible
  );
  const { isRendered, isVisible, layout } = useRosterWindow({
    avatarMenuOpen: Boolean(avatarMenu),
    onClose: hidePersonRoster,
    open: personRosterVisible,
  });

  if (!isRendered || layout === null) {
    return null;
  }

  return (
    <FloatingWindowRenderer
      blocksHover={true}
      containerClassName="glass fixed z-[1000] flex rounded-xl p-2"
      contentClassName="relative"
      panelClassName="box-border"
      panelRole="dialog"
      positionStyle={layout.positionStyle}
    >
      <div
        className={`origin-top-right transform-gpu transition-all ease-out motion-reduce:transition-none ${
          isVisible
            ? "translate-y-0 scale-100 opacity-100"
            : "pointer-events-none -translate-y-1 scale-[0.985] opacity-0"
        }`}
        data-roster
        style={{
          ...layout.panelStyle,
          transitionDuration: `${ROSTER_WINDOW_TRANSITION_MS}ms`,
        }}
      >
        <FloatingWindowCard
          className="w-full"
          onClose={hidePersonRoster}
          padding="wide"
        >
          <div className="flex min-h-0 flex-1 flex-col">
            <h2 className="m-0 text-xl font-semibold">People</h2>
            <div className="mt-3 flex min-h-0 flex-1 overflow-hidden">
              <RosterView />
            </div>
          </div>
        </FloatingWindowCard>
      </div>
    </FloatingWindowRenderer>
  );
};
